import React, { useState } from "react";
import { Button, Divider, Modal } from "antd";
import { MainText, SubText } from "../../../../helpers/StyledComponents";

const TITLE = "OUR AIMS";
const OurAimsModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="primary"
        onClick={() => setOpen(true)}
        style={{ width: "100px" }}
      >
        <div>{TITLE}</div>
      </Button>
      <Modal
        centered
        open={open}
        onCancel={() => setOpen(false)}
        width={1000}
        footer={null}
      >
        <MainText align="center">{TITLE}</MainText>
        <Divider />
        <SubText>
          Working with the churches, Scripture Union aims:
          <ul>
            <li>
              to make God's Good News known to children, young people and
              families and
            </li>
            <li>
              to encourage people of all ages to meet God daily through the
              Bible and prayer
            </li>
          </ul>
          so that they may
          <ul>
            <li>come to personal faith in our Lord Jesus Christ</li>
            <li>grow in Christian maturity</li>
            <li>
              become both committed church members and servants of a world in
              need.
            </li>
          </ul>
          <i>
            Scripture Union pursues these aims through a variety of specialist
            ministries around the world in obedience to our Lord Jesus Christ
            and in reliance on the Holy Spirit.
          </i>
        </SubText>
      </Modal>
    </>
  );
};

export default OurAimsModal;
